import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { State, process } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FlowManagementService } from '../services/flow-management.service';
import { Router, NavigationEnd } from '@angular/router';
import { Settings } from '../flows/settings';
import { StorageRouterService } from '../services/storage-router.service';

@Component({
    selector: 'app-approvals',
    templateUrl: './approvals.component.html',
    styleUrls: ['./approvals.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class ApprovalsComponent implements OnInit {

  apiRoot: string = "https://flow.microsoft.com";
  navigationSubscription: Subscription;
  environment: string;
  approvalRequests: any[] = [];
  state: State = {
    skip: 0,
    take: this.approvalRequests.length,

    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: [] //[{ field: 'ProductName', operator: 'contains', value: 'Chef' }]
    },
    sort: [
      {
        'field': 'displayName',
        'dir': 'asc'
      }
    ]
  };
  view: GridDataResult = process(this.approvalRequests, this.state);
  loading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  loaded = false;
  public selection: string[] = [];

  @ViewChild('approvalsgrid', {static: true}) grid;

  constructor(
    private flowManagementService: FlowManagementService,
    private router: Router,
    private storageDexieService: StorageRouterService
  ) {

  }

  ngOnInit() {
    this.storageDexieService.getConfig(Settings.SETTING_AR_GRIDSTATE).then((settings) => {
      if (settings && settings.value) {
        this.dataStateChange(settings.value);
      }
    });
    this.storageDexieService.putConfig(Settings.SETTING_LASTROUTE, {
      key: Settings.SETTING_LASTROUTE,
      'value': '/approvals'
    });

    this.flowManagementService.currentEnvironment$.subscribe((environment) => {
      this.refreshEnvironment(environment);
    });
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.refreshEnvironment(this.environment, true);
      }
    });
    this.checkToken();
  }

  checkToken() {
    if (this.flowManagementService && this.flowManagementService.currentEnvironment) {
      this.refreshEnvironment(this.flowManagementService.currentEnvironment);
      return;
    }
    setTimeout(this.checkToken, 500);
  }

  get ready(): boolean {
    var env = this.flowManagementService.currentEnvironment;
    return this.loaded && !!env;
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  private refreshEnvironment(env: string, force: boolean = false) {
    if (!env) {
      return;
    }
    if (env == this.environment && !force) {
      return;
    }
    // this.flowManagementService.getEnvironment(env).subscribe((env)=> {
    //     this.apiRoot = env.json().properties.runtimeEndpoints["microsoft.Flow"].replace(".api", "");
    // });
    this.environment = env;

    this.loading$.next(true);

    var pApprovalRequests = this.flowManagementService.getApprovals(this.environment);

    //this.flowManagementService.getApprovalByOwner(this.environment, '36e3b856-3c2e-4605-ac5f-99064d229c3a');
    //this.flowManagementService.getApprovalByOwner(this.environment, 'b2e3adeb-1359-4a83-9f28-c772ad033f34');

    //this.flowManagementService.getApprovalRequests(this.environment, 'b2e3adeb-1359-4a83-9f28-c772ad033f34');

    //this.flowManagementService.getApprovalViews(this.environment);

    pApprovalRequests.then((approvalRequests) => {
      this.approvalRequests = approvalRequests;
      this.state.take = this.approvalRequests.length;
    }).then(() => {
      this.loading$.next(false);
      this.view = process(this.approvalRequests, this.state);
      this.loaded = true;
    });
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.storageDexieService.putConfig(Settings.SETTING_AR_GRIDSTATE, {
      key: Settings.SETTING_AR_GRIDSTATE,
      value: state
    });
    this.view = process(this.approvalRequests, this.state);
  }

  public onSelect({ dataItem, item }): void {

    switch (item) {
      case "Cancel": {

        this.onCancel(dataItem);

        break;
      }
      case "Export Excel": {
        this.grid.saveAsExcel();
        break;
      }
      default:
    }
  }


  private onCancel(dataItem: any) {

    var promises = [];
    if (this.selection.length) {
      for (var i = 0; i < this.selection.length; i++) {
        let ar = this.approvalRequests.find(r => r.name == this.selection[i]);

        //console.log(run.name);
        let p = this.flowManagementService.cancelApproval(this.environment, ar.approval.name).then((approval) => {
          //dataItem.flowState = "Stopped";
          Object.assign(ar.raw.properties.approval, approval);
        });
        promises.push(p);
      }

      Promise.all(promises).then(() => {
        // return this.flowManagementService.getFlowRuns(this.flow, this.deep, true, this.admin);
      }).then(() => {
        // this.view = process(this.approvalRequests, this.state);
      } /*, ()=> {
        this.flowManagementService.serviceStatus$.next('Delete run failed - the preview API is not active in your tenant yet.');
      } */);

    }
    else {
      let p = this.flowManagementService.cancelApproval(this.environment, dataItem.approval.name).then((approval) => {
        //dataItem.flowState = "Stopped";
        Object.assign(dataItem.raw.properties.approval, approval);
      });
      promises.push(p);
    }
  }

  /** Cancel only the rows the user has explicitly selected. No-op if selection is empty. */
  public onCancelSelected(): void {
    if (!this.selection?.length) return;
    this.onCancel(null);
  }

  /** Export every loaded approval to Excel — independent of the current selection. */
  public onExportAll(): void {
    this.grid.saveAsExcel();
  }
}
